import { render, staticRenderFns } from "./BrowseItems.vue?vue&type=template&id=c3280726"
import script from "./BrowseItems.vue?vue&type=script&lang=ts"
export * from "./BrowseItems.vue?vue&type=script&lang=ts"
import style0 from "./BrowseItems.vue?vue&type=style&index=0&id=c3280726&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports